import GlobalJewelryCategoryComp from "../../../reports/GlobalJewelry/GlobalJewelryCategoryComp";
import GlobalJewelryMetalTypeComp from "../../../reports/GlobalJewelry/GlobalJewelryMetalTypeComp";
import GlobalJewelryPriceComp from "../../../reports/GlobalJewelry/GlobalJewelryPriceComp";
import AdminJewelryVendorClicksComp from "../AdminJewelryVendorClicksComp";
import AdminJewelryRetailerClicksComp from "../AdminJewelryRetailerClicksComp";
import { isValidMetalType } from "../../../reports/jewelry/_shared/isValidMetalType";

// Admin's Category/Metal Type/Price chart endpoints (Admin_JewelryReportService)
// return the exact same field casing as Global's (both go through the same
// Admin-stack C# service), so the chart cards are reused directly rather than
// duplicated. Vendor/Retailer Clicks have no Global equivalent (skipped
// there, per user-confirmed scope) so those get Admin-only components.
export const ADMIN_CATEGORY_CONFIG = {
  key: "adminCategory",
  dataKey: "JewelryCategorySearches",
  labelField: "category",
  valueField: "count",
  dimensionLabel: "Category",
  pageTitle: "Jewelry Category Report",
  ChartCard: GlobalJewelryCategoryComp,
  noiseFilter: null,
  hideTotalDimensionSum: true,
  showTop3Concentration: true,
  totalClicksKey: "JewelryTotalClicks",
  detail: { filterParamName: "category", fileNamePart: "AdminJewelryCategoryReports" },
};

export const ADMIN_METAL_TYPE_CONFIG = {
  key: "adminMetalType",
  dataKey: "JewelryMetalTypeSearches",
  labelField: "metalType",
  valueField: "count",
  dimensionLabel: "Metal Type",
  pageTitle: "Jewelry Metal Type Report",
  ChartCard: GlobalJewelryMetalTypeComp,
  noiseFilter: { isValid: isValidMetalType, toggleLabel: "Hide None / unspecified" },
  hideTotalDimensionSum: true,
  showTop3Concentration: true,
  totalClicksKey: "JewelryTotalClicks",
  detail: { filterParamName: "metalType", fileNamePart: "AdminJewelryMetalTypeReports" },
};

export const ADMIN_PRICE_CONFIG = {
  key: "adminPrice",
  dataKey: "JewelryPriceSearches",
  labelField: "range",
  valueField: "total",
  dimensionLabel: "Price Band",
  pageTitle: "Jewelry Price Report",
  ChartCard: GlobalJewelryPriceComp,
  noiseFilter: null,
  hideTotalDimensionSum: true,
  showTop3Concentration: true,
  totalClicksKey: "JewelryTotalClicks",
  detail: { filterParamName: "price", fileNamePart: "AdminJewelryPriceReports" },
};

export const ADMIN_VENDOR_CLICKS_CONFIG = {
  key: "adminVendorClicks",
  dataKey: "JewelryVendorClicksSearches",
  labelField: "dealerCompany",
  valueField: "total",
  dimensionLabel: "Vendor",
  pageTitle: "Jewelry Vendor Clicks Report",
  ChartCard: AdminJewelryVendorClicksComp,
  noiseFilter: null,
  hideTotalDimensionSum: true,
  showTop3Concentration: true,
  totalClicksKey: "JewelryTotalClicks",
  detail: { filterParamName: "vendor", fileNamePart: "AdminJewelryVendorClicksReports" },
};

export const ADMIN_RETAILER_CLICKS_CONFIG = {
  key: "adminRetailerClicks",
  dataKey: "JewelryRetailerClicksSearches",
  labelField: "dealerCompany",
  valueField: "total",
  dimensionLabel: "Retailer",
  pageTitle: "Jewelry Retailer Clicks Report",
  ChartCard: AdminJewelryRetailerClicksComp,
  noiseFilter: null,
  hideTotalDimensionSum: true,
  showTop3Concentration: true,
  totalClicksKey: "JewelryTotalClicks",
  detail: { filterParamName: "retailer", fileNamePart: "AdminJewelryRetailerClicksReports" },
};
